import { useTranslation } from 'react-i18next'

import ConnectionIcon from 'app/common/presentation/Connection/ConnectionIcon'
import { AvailableConnection } from 'app/connections/types'

import { Button, Chip } from 'components'

import styles from './ConnectionCard.module.scss'

export type ConnectionCardConnection = {
  description: string
  displayName: string
} & AvailableConnection

type ConnectionCardProps = {
  connection: ConnectionCardConnection
  connected: boolean
  onConnect: () => unknown
  onManage: () => unknown
}

const ConnectionCard = ({ connected, connection, onConnect, onManage }: ConnectionCardProps) => {
  const { t } = useTranslation('connections')

  return (
    <article className={styles.card}>
      <div className={styles.content}>
        <div className={styles.header}>
          <div className={styles.titleGroup}>
            <div className={styles.icon}>
              <ConnectionIcon connection={connection} />
            </div>
            <div>
              <h2>{connection.displayName}</h2>
              <div className={styles.category}>{t(`category.${connection.category}`)}</div>
            </div>
          </div>
          {connected && <Chip color="green">{t('overview.browse.connected')}</Chip>}
        </div>
        <p>{connection.description}</p>
      </div>
      <Button
        onClick={connected ? onManage : onConnect}
        variant={connected ? 'secondary' : 'primary'}
      >
        {t(connected ? 'overview.browse.manage' : 'overview.browse.connect')}
      </Button>
    </article>
  )
}

export default ConnectionCard
